import { useAppSelector } from '../../../core/redux/hooks/useAppSelector';
import { selectGameType } from '../selectors';
import { useGetPrincipalMeQuery, useGetScoreQuery } from '../services/GameService';

export const useGameData = () => {
  const gameType = useAppSelector(selectGameType);
  const { data: userData } = useGetPrincipalMeQuery();
  const { data: scoreData } = useGetScoreQuery({ gameCode: gameType });

  return { userData, scoreData };
};
